// 工单管理相关接口
import download from '../../download'
import request from '../../request'

// 新增工单申请（幂等：requestId为前端生成的UUID）
export function addWorkOrder(data) {
    return request({
        url: '/office-service/oa/workOrder/add',
        data,
        method: 'post',
    })
}

// 工单重新提交（已驳回）
export function resubmitWorkOrder(data) {
    return request({
        url: '/office-service/oa/workOrder/resubmit',
        data,
        method: 'post',
    })
}

// 工单更新（仅已终止）
export function updateWorkOrder(data) {
    return request({
        url: '/office-service/oa/workOrder/update',
        data,
        method: 'post',
    })
}

// 我的工单列表
export function fetchMineList(params) {
    return request({
        url: '/office-service/oa/workOrder/mine',
        params,
    })
}

// 待处理工单列表
export function fetchPendingList(params) {
    return request({
        url: '/office-service/oa/workOrder/pending',
        params,
    })
}

// 已处理工单列表
export function fetchDoneList(params) {
    return request({
        url: '/office-service/oa/workOrder/done',
        params,
    })
}

// 已处理工单导出（xlsx，复用列表查询条件）
export function exportDoneList(params) {
    return download({
        url: '/office-service/oa/workOrder/done/export',
        method: 'get',
        data: params,
    })
}

// 工单详情
export function fetchDetail(id) {
    return request({
        url: '/office-service/oa/workOrder/detail/' + id,
    })
}

// ---------------- 工单配置 ----------------

// 新增工单配置
export function addConfig(data) {
    return request({
        url: '/office-service/oa/workOrder/config/add',
        data,
        method: 'post',
    })
}

// 更新工单配置
export function updateConfig(data) {
    return request({
        url: '/office-service/oa/workOrder/config/update',
        data,
        method: 'post',
    })
}

// 工单配置启用/停用切换
export function toggleConfig(id) {
    return request({
        url: '/office-service/oa/workOrder/config/toggle/' + id,
        method: 'post',
    })
}

// 工单配置分页列表
export function fetchConfigList(params) {
    return request({
        url: '/office-service/oa/workOrder/config/list',
        params,
    })
}

// 工单配置全部列表（下拉用）
export function fetchConfigAll() {
    return request({
        url: '/office-service/oa/workOrder/config/listAll',
    })
}

// 按工单类型+涉及模块+申请分类匹配配置
export function fetchConfigMatch(params) {
    return request({
        url: '/office-service/oa/workOrder/config/match',
        params,
    })
}
